(() => {
  const SELECTOR_NUM = '.cart-link__bubble-num';
  const SELECTOR_BUBBLE = '.cart-link__bubble';
  const STORE_KEY = 'unique_cart_count';

  const state = { locked: null, observer: null };

  function getEls() {
    const numEl = document.querySelector(SELECTOR_NUM);
    const bubbleEl = document.querySelector(SELECTOR_BUBBLE);
    return { numEl, bubbleEl };
  }

  function applyCount(count) {
    const { numEl, bubbleEl } = getEls();
    if (!numEl || !bubbleEl) return;

    state.locked = Number.isFinite(count) ? count : 0;

    // Ставим текст
    numEl.textContent = String(state.locked);

    // Видимость bubble
    if (state.locked > 0) {
      bubbleEl.classList.add('cart-link__bubble--visible');
    } else {
      bubbleEl.classList.remove('cart-link__bubble--visible');
    }

    // Запоминаем, чтобы на следующей странице было мгновенно
    try { sessionStorage.setItem(STORE_KEY, String(state.locked)); } catch (_) {}
  }

  function getInitialCountFromDOMorStore() {
    const { numEl } = getEls();
    // 1) самое лучшее — то, что уже отдал Liquid (unique)
    const domVal = numEl ? parseInt(numEl.textContent, 10) : NaN;
    if (Number.isFinite(domVal)) return domVal;

    // 2) запасной — из sessionStorage
    const stored = parseInt(sessionStorage.getItem(STORE_KEY) || '', 10);
    if (Number.isFinite(stored)) return stored;

    return 0;
  }

  function lockAgainstThemeWrites() {
    const { numEl } = getEls();
    if (!numEl) return;

    if (state.observer) state.observer.disconnect();

    state.observer = new MutationObserver(() => {
      const current = parseInt(numEl.textContent || '0', 10);
      if (!Number.isFinite(current)) return;

      // Если тема записала item_count (или что-то иное) — возвращаем locked мгновенно
      if (state.locked != null && current !== state.locked) {
        numEl.textContent = String(state.locked);
      }
    });

    state.observer.observe(numEl, {
      characterData: true,
      childList: true,
      subtree: true,
    });
  }

  async function refreshFromCartJs() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      const uniqueCount = Array.isArray(cart.items) ? cart.items.length : 0;
      applyCount(uniqueCount);
    } catch (_) {}
  }

  function hookCartAjax() {
    // fetch
    const origFetch = window.fetch;
    window.fetch = async (...args) => {
      const result = await origFetch(...args);
      try {
        const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;
        if (url && /\/cart\/(add|change|update)\.js/.test(url)) {
          // Дать теме обновить разметку, но “замок” уже стоит и не даст увидеть флеш
          setTimeout(refreshFromCartJs, 0);
        }
      } catch (_) {}
      return result;
    };

    // XHR
    const origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this.addEventListener('load', () => {
        try {
          if (url && /\/cart\/(add|change|update)\.js/.test(url)) {
            setTimeout(refreshFromCartJs, 0);
          }
        } catch (_) {}
      });
      return origOpen.call(this, method, url, ...rest);
    };
  }

  function init() {
    // Always fetch from API — don't trust DOM which may have theme's item_count
    lockAgainstThemeWrites();
    hookCartAjax();
    refreshFromCartJs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();